import { Pipe, PipeTransform } from '@angular/core';

import { Account } from '@personal-area/global/accounts/models';

export const webTraderLinkSetup = (url: string, account: Account | null) =>
  url + (!account || account.type === 'tp'
    ? ''
    : account.extras.server.type === 'mt5'
      ? `?type=${account.extras.server.type.replace(/\D/g, '')}&login=${account.login}&account=${account.isDemo ? 'demo' : 'real'}`
      : `?type=${account.extras.server.type.replace(/\D/g, '')}&login=${account.login}&name=${account.extras.server.name}`
  );

@Pipe({
  name: 'webTraderLinkSetup',
  standalone: true,
})
export class WebTraderLinkSetupPipe implements PipeTransform {
  public transform(url: string, account: Account | null): string {
    return webTraderLinkSetup(url, account);
  }
}
